module.exports = __webpack_public_path__ + "static/media/img3.125a6e86.png";